import React from 'react'
import Footer from '../components/common/Footer'
function Home() {
  return (
    
    <div>
        <div className="min-h-[calc(100vh-5.8rem)] flex justify-center items-center  pt-8 home-page">

       

    </div>
    <div className='bg-text text-3xl'>
        Welcome to MK Ponda College Digital Library 
        <p className='text-xl text-caribbeangreen-500 bg-white mt-3 p-2 rounded-lg'>Please Contact to Librarian For Login Id Password</p>
        </div>
    <Footer />

    </div>
   
  )
}

export default Home